// approutes.tsx
import { HomePage, Configuracion, Inventario, Liquidaciones, DashBoard, Creditos, Materiales, OrdenesCompra, MisServicios, ResumenGanancias, Facturacion, Preservicios } from './pages';
import { withNavigationWatcher } from './context/navigation';

const routes = [
  {
    path: '/home',
    element: DashBoard,
    name: 'Principal',
    permission: '',
  },
  {
    path: '/servicios',
    element: HomePage,
    name: 'Servicios',
    permission: 'Prm_Serv_Ver',
  },
  {
    path: '/inventario',
    element: Inventario,
    name: 'Inventario',
    permission: 'Prm_Invent_Ver',
  },
  {
    path: '/liquidaciones',
    element: Liquidaciones,
    name: 'Liquidaciones',
    permission: 'Prm_Liquid_Ver',
  },
  {
    path: '/Creditos',
    element: Creditos,
    name: 'Créditos',
    permission: 'Prm_Credito_Ver',
  },
  {
    path: '/Materiales',
    element: Materiales,
    name: 'Materiales',
    permission: 'Prm_Mat_Ver',
  },
  // {
  //   path: '/OrdenesCompra',
  //   element: OrdenesCompra,
  //   name: 'OrdenesCompra',
  //   permission: 'Prm_OrdenCompra_Ver',
  // },
  {
    path: '/ResumenGanancias',
    element: ResumenGanancias,
    name: 'Resumen de ganancias',
    permission: 'Prm_ResumenGanan_Ver',
  },
  {
    path: '/Configuracion',
    element: Configuracion,
    name: 'Configuración',
    permission: 'Prm_Config',
  },
  {
    path: '/MisServicios',
    element: MisServicios,
    name: 'Mis Servicios',
    permission: 'Prm_MisServicios_Ver',
  },
  {
    path: '/Facturacion',
    element: Facturacion,
    name: 'Facturación',
    permission: 'Prm_Fact_Ver',
  },
  {
    path: '/Preservicios',
    element: Preservicios,
    name: 'Preservicios',
    permission: 'Prm_Preservicio_Ver',
  },
];

export default routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
